import styled from 'styled-components';
import { animated } from '@react-spring/web';
import { Heading3Styles } from '../typography';
import { Z_INDEXES } from '../../../src/styled/global-variables';
import { getColor, getSizeBy, getColorShade, getThemeProp, getElevation } from '../../../src/styled/utils';
import { BorderBottom } from '../../../src/styled/shared-styles';
export const Wrapper = styled.div `
  z-index: ${Z_INDEXES.LIGHTBOX};
  flex-grow: 1;
  height: 100%;
  background-color: ${getColor('surface')};
  border: 1px solid ${getColorShade('onSurface', 'border')};
  border-radius: ${getThemeProp('widgetsBorderRadius')}px;
  box-shadow: ${getElevation(4)};
`;
export const Header = styled.div `
  display: flex;
  align-items: center;
  justify-content: start;
  width: 100%;
  height: 48px;
  padding: 0 ${getSizeBy(4)};
  ${BorderBottom}
`;
export const HeaderTitle = styled(animated.h1) `
  flex-grow: 1;
  color: ${getColorShade('onSurface', 'mediumEmphasis')};
  ${Heading3Styles}
`;
export const InnerWrapper = styled.div `
  display: grid;
  grid-gap: ${getSizeBy(6)};
  grid-template-columns: 3fr 1fr;
  height: calc(100% - 48px);
`;
export const Main = styled(animated.div) `
  grid-row: 1 / -1;
  grid-column: 1 / -1;
  overflow: auto;
  will-change: transform;
`;
